<template>
  <div>
    <div class="container-fluid">
      <div class="row gameplay_pg">
        <div class="iframe_section">
          <iframe id="addOnGamePenalty" src="/static/penalty_kicks/index.html" frameborder="0"></iframe>
        </div>
      </div>
    </div>

    <post-penalty-game
      v-if="isPostGameModalOpen"
      @proceed="closePostGameModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import PostPenaltyGame from '../../modals/PostPenaltyGame.vue';

export default {
  name: 'PenaltyGame',
  components: { PostPenaltyGame },
  data () {
    return {
      isPostGameModalOpen: false,
    };
  },
  mounted () {
    this.translateTexts();

    window.addEventListener('message', this.receiveMessage);
  },
  beforeDestroy () {
    this.resetAddOnGameData();
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'updateAddOnGameData',
      'resetAddOnGameData',
    ]),
    translateTexts () {
      const iframe = document.querySelector('#addOnGamePenalty');

      if (!iframe) { return; }

      iframe.onload = () => {
        if (!iframe.contentWindow) { return; }

        const translationMap = {
          TEXT_HELP: 'add_on_game_penalty_text_help',
          TEXT_CONGRATULATION: [
            'add_on_game_penalty_text_congratulation_1',
            'add_on_game_penalty_text_congratulation_2',
            'add_on_game_penalty_text_congratulation_3',
          ],
          TEXT_BALL_OUT: 'add_on_game_penalty_text_out',
          TEXT_SAVED: 'add_on_game_penalty_text_saved',
        };

        Object.entries(translationMap).forEach(([key, value]) => {
          if (iframe.contentWindow[key]) {
            if (Array.isArray(value)) {
              iframe.contentWindow[key] = value.map((v) => this.getTranslations[v]);
            } else {
              iframe.contentWindow[key] = this.getTranslations[value];
            }
          }
        });
      };
    },
    receiveMessage (event) {
      if (event.data.key !== 'finishPenaltyGame') { return; }

      window.removeEventListener('message', this.receiveMessage);

      this.updateAddOnGameData({ success: event.data.payload.ballIn });

      this.openPostGameModal();
    },
    openPostGameModal () {
      this.isPostGameModalOpen = true;

      this.$nextTick(() => {
        $('.modal,.modal-overlay').fadeIn(200);

        $('.modal-close, .modal-overlay').click(() => {
          this.closePostGameModal();
        });
      });
    },
    closePostGameModal () {
      $('.modal, .modal-overlay').fadeOut();

      this.isPostGameModalOpen = false;

      this.getUserLoginDetails().then(() => {
        this.$router.push('/home');
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addOn/PenaltyGame.vue